import { useMutation } from "react-query";
import { getProductMeasurementTaskInfo } from "components/measuring/lib/measuring-data";
import { uniqBy } from "lodash";

export const useMeasurementStatus = () => {
    return useMutation(({ taskContextKeys, isInDuplicateStaging }) => {
        return getProductMeasurementTaskInfo(taskContextKeys, isInDuplicateStaging).then((data) => {
            const activeMeasurements = data.sort((a, b) => new Date(b.taskCreatedOn) - new Date(a.taskCreatedOn));
            const upcsWithMeasurementStatus = uniqBy(activeMeasurements, "taskContextKey").sort(
                (a, b) => new Date(a.taskCreatedOn) - new Date(b.taskCreatedOn),
            );

            return upcsWithMeasurementStatus;
        });
    });
};
